import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: string;
  title: string;
  category_parent_name: string;
  category_term_id: string;
  category_name_1: string;
  category_name: string;
  category_airport_key: string;
  address_english: string;
  address_malay: string;
  address_mandarin: string;
  location_direction: string;
  fax: string;
  key: string;
  latitude: string;
  longitude: string;
  short_form: string;
  tel: string;
  value: string;
  airport_location_redirect: string;
  parent_term_name: string;
  name: string;
  parent_term_id: string;
  published: boolean;
}

// edit api call
const fetchAirportLocDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await passengerCMSApi.get(`/api/airport-locations-data/${id}`);
  return response?.data[0];
};

const useAirportLocDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["levelDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchAirportLocDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useAirportLocDocumentDetails };
